module.exports = __webpack_public_path__ + "static/media/price-sc.e2c3f066.png";